import Friends from './ui/main/Friends';

export default Friends;
